import type { SVGProps } from 'react';
const SvgBookBookmarked2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M17 0H5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h1v3.5a.502.502 0 0 0 .725.447l1.775-.888 1.775.888a.497.497 0 0 0 .487-.022.502.502 0 0 0 .237-.425V20h6c1.653 0 3-1.347 3-3V3c0-1.653-1.347-3-3-3zM6 2h9v16H6V2zm4 20.691-1.275-.638a.49.49 0 0 0-.447 0L7 22.691V20h3v2.691zM18 17c0 .55-.45 1-1 1h-1V2h1c.55 0 1 .45 1 1v14z" />
    <path d="M13.5 4h-6c-.275 0-.5.225-.5.5v3c0 .275.225.5.5.5h6c.275 0 .5-.225.5-.5v-3c0-.275-.225-.5-.5-.5zM13 7H8V5h5v2z" />
  </svg>
);
export default SvgBookBookmarked2;
